import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HttpModule, Http } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";

import "hammerjs";

// Modules
import { SharedModule } from "./shared/shared.module";

// Directives
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Sidebar_Directives } from "./shared/directives/side-nav.directive";
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

// Routing Module
import { AppRoutes } from "./app.routing";

// Components
import { AppComponent } from "./app.component";
import { CommonLayoutComponent } from "./common/common-layout/common-layout.component";
import { AdminCommonLayoutComponent } from "./common/admin-common-layout/admin-common-layout.component";

import { AuthenticationLayoutComponent } from "./common/authentication-layout/authentication-layout.component";
import { EventLayoutComponent } from "./common/event-layout/event-layout.component";

// Services
import { ApiService } from "./services/api.service";
import { AuthGuard } from "./services/authentication.service";
import { DashGuard } from "./services/admincheck.service";
import { EventNameService } from "./services/event-name.service";
import { SpinnerService } from "./services/spinner.service";
import { GlobalService } from "./services/global.service";
import { ModuleClearService } from "./services/module-clear.service";

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, { useHash: true }),
    NgbModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: "toast-top-right",
      preventDuplicates: true,
    }),
    SharedModule,
    HttpClientModule,
  ],
  declarations: [
    AppComponent,
    CommonLayoutComponent,
    AuthenticationLayoutComponent,
    AdminCommonLayoutComponent,
    EventLayoutComponent,
    Sidebar_Directives,
  ],
  providers: [
    ApiService,
    AuthGuard,
    DashGuard,
    SpinnerService,
    EventNameService,
    GlobalService,
    ModuleClearService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/app.module.ts